import type { LoadType } from '@dicetechnology/vesper-sdk-web';
import clsx from 'clsx';

import VesperPlayer from '.';

import Image from '@shared/Image';
import VideoLock from '@shared/VideoLock';
import type { UefatvEditorialContent } from '@shared-types/uefatv.types';
import { AccessLevel } from '@shared-types/uefatv.types';
import { competitionFolder, imgBaseUrl } from '@utilities/WindowContext';

import * as classes from './styles.module.scss';
export const PlayerWithLock = ({ video, type }: { video: UefatvEditorialContent; type: LoadType }) => {
  const fallbackImg = competitionFolder
    ? `${imgBaseUrl}/imgml/uefacom/${competitionFolder}/fallback.jpg`
    : `${imgBaseUrl}/imgml/void.png`;
  if (!video) return null;

  const videolockTrack = {
    impressionAction: 'Login to watch uefatv',
    impressionName: 'login_to_watch_uefatv_impression',
    clickAction: 'Login to watch uefatv',
    clickName: 'login_to_watch_uefatv_click',
  };

  return (
    <div className={classes.container}>
      {video.accessLevel !== AccessLevel.GRANTED && (
        <>
          <Image
            className={clsx(classes.previewImage)}
            title={video.title}
            src={video.mainMedia?.image?.wide?.w1}
            fallback={fallbackImg}
          />
          <VideoLock videoid={video.id} videoTitle={video.title} trackingProps={videolockTrack} videoKind='uefatv' />
        </>
      )}
      {video.accessLevel === AccessLevel.GRANTED && <VesperPlayer id={video.id} type={type} />}
    </div>
  );
};
